import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Home from './page/Home'
import LMS from './page/LMS'
import LOS from './page/LOS'

const Router = () => {
  return (
    <Switch>
      <Route exact path='/' component={Home} />
      <Route exact path='/lms' component={LMS} />
      <Route exact path='/los' component={LOS} />
      <Route component={() => <div>404 Page not found</div>} />
    </Switch>
  )
}

export default Router
